import { useEffect } from "react";
import { useCurrentUserZenDeskJwtQuery } from "src/components/ZendeskWidget.generated";
import { getStage } from "src/context";
import { useAppNotificationsContext } from "src/contexts/AppNotificationsContext";

/** Type-safe wrapper around Zendesk's global `zE` function. */
function zE(command: string, action: string, callback?: Function) {
  if (callback) {
    (window as any).zE(command, action, callback);
  } else {
    (window as any).zE(command, action);
  }
}

export function ZendeskWidget() {
  const { refetch: getUserJWT } = useCurrentUserZenDeskJwtQuery({ skip: true });
  const { push } = useAppNotificationsContext();

  useEffect(
    () => {
      // Even qa doesn't have a zendesk token, so only use this in prod
      if (getStage() !== "prod") return;

      const script = document.createElement("script");
      script.src = "https://static.zdassets.com/ekr/snippet.js?key=52f61412-865a-4480-b160-6d68e0337ea4";
      script.id = "ze-snippet";

      // Commands from https://developer.zendesk.com/api-reference/widget-messaging/web/core/
      script.onload = () => {
        zE("messenger", "hide");
        zE("messenger", "loginUser", function (callback: (jwt: string | undefined) => void) {
          void getUserJWT().then(function ({ data }) {
            callback(data.currentUser?.zendeskJwt);
          });
        });
        zE("messenger:on", "unreadMessages", function (count: number) {
          if (count > 0) {
            push(`You have ${count} unread message(s).`);
          }
        });
      };
      document.body.appendChild(script);
      return () => {
        zE("messenger", "logoutUser");
        document.body.removeChild(script);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return <></>;
}

export function openZendesk() {
  zE("messenger", "show");
  zE("messenger", "open");
}
